import { FC, ReactNode, createContext, useState } from "react";

import { IPaymentContext } from "../types/payment";

export const PaymentContext = createContext<IPaymentContext | null>(null);

interface Props {
  children: ReactNode;
}

const PaymentProvider: FC<Props> = ({ children }) => {
  const [total, setTotal] = useState<number | null>(null);

  return (
    <PaymentContext.Provider
      value={{
        total,
        setTotal,
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
};

export default PaymentProvider;
